module.exports = __webpack_public_path__ + "static/media/javascript-object-oriented-programming.1bceffd9.jpg";